import { ApiErrorResultType } from "util/request/types";
import { create } from "zustand";
import { useAlertStore } from "./alertStore";

interface ErrorState {
  error: ApiErrorResultType | null;
  setError: (error: ApiErrorResultType) => void;
  clearError: () => void;
}

export const useErrorStore = create<ErrorState>((set) => ({
  error: null,
  setError: (error) => {
    set({ error });
    if (error.isShow !== false) {
      useAlertStore.getState().showAlert({ message: error.errorMessage });
    }
  },
  clearError: () => set({ error: null }),
}));
